
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const PavingEstimate = lazy(() => import('../pages/services/paving-estimate/page'));
const MaintenanceServices = lazy(() => import('../pages/services/maintenance-services/page'));
const Products = lazy(() => import('../pages/services/products/page'));
const CommercialAsphalt = lazy(() => import('../pages/services/commercial-asphalt/page'));
const AsphaltRepair = lazy(() => import('../pages/services/asphalt-repair/page'));
const ConcreteDriveway = lazy(() => import('../pages/services/concrete-driveway/page'));
const Sealcoating = lazy(() => import('../pages/services/sealcoating/page'));
const PotholeRepair = lazy(() => import('../pages/services/pothole-repair/page'));
const ParkingLot = lazy(() => import('../pages/services/parking-lot/page'));
const CostsEstimates = lazy(() => import('../pages/services/costs-estimates/page'));
const BestContractors = lazy(() => import('../pages/services/best-contractors/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogPost = lazy(() => import('../pages/blog/post/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/services/paving-estimate',
    element: <PavingEstimate />,
  },
  {
    path: '/services/maintenance-services',
    element: <MaintenanceServices />,
  },
  {
    path: '/services/products',
    element: <Products />,
  },
  {
    path: '/services/commercial-asphalt',
    element: <CommercialAsphalt />,
  },
  {
    path: '/services/asphalt-repair',
    element: <AsphaltRepair />,
  },
  {
    path: '/services/concrete-driveway',
    element: <ConcreteDriveway />,
  },
  {
    path: '/services/sealcoating',
    element: <Sealcoating />,
  },
  {
    path: '/services/pothole-repair',
    element: <PotholeRepair />,
  },
  {
    path: '/services/parking-lot',
    element: <ParkingLot />,
  },
  {
    path: '/services/costs-estimates',
    element: <CostsEstimates />,
  },
  {
    path: '/services/best-contractors',
    element: <BestContractors />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPost />,
  },
  {
    path: '/privacy-policy',
    element: <Privacy />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
